import React from "react";

import { Pill } from "../Pill";

import styles from "./MultiSelect.scss";
import { MultiSelectItem } from "./MultiSelectItem";
interface MultiSelectPillProps<T extends string = string> {
  tabIndex: number;
  item: MultiSelectItem<T>;
  onRemoveSelection: (item: MultiSelectItem<T>) => void;
  removeAriaLabel?: string;
}

export const MultiSelectPill = <T extends string = string>({
  tabIndex,
  item,
  onRemoveSelection,
}: MultiSelectPillProps<T>) => (
  <Pill
    tabIndex={tabIndex}
    onKeyPress={() => onRemoveSelection(item)}
    data-testid="tag-selector-pill"
    text={item.text}
    onClick={() => onRemoveSelection(item)}
    size="large"
    className={styles["default-selection-pill"]}
    onClose={() => onRemoveSelection(item)}
  ></Pill>
);

interface RenderDefaultSelectionProps<T extends string = string> {
  tabIndex: number;
  item: MultiSelectItem<T>;
  onRemoveSelection: (item: MultiSelectItem<T>) => void;
}

export const renderDefaultSelection = <T extends string = string>({
  tabIndex,
  item,
  onRemoveSelection,
}: RenderDefaultSelectionProps<T>) => {
  return (
    <MultiSelectPill
      tabIndex={tabIndex}
      key={item.id}
      item={item}
      onRemoveSelection={() => onRemoveSelection(item)}
    />
  );
};
